import { useState } from "react";
import { useSelector } from "react-redux";
import SocialMediaBtn from "./SocialMediaBtn";
import FollowFollowingSection from "./FollowFollowingSection";
import FollowButton from "pages/userProfile/shared/FollowButton";
import UserEditProfileButton from "pages/userProfile/shared/UserEditProfileButton";
import NewChatButton from "pages/UserChat/shared/NewChatButton";
import LoginModel from "components/LoginModal";
import PrivateAccount from "pages/userProfile/shared/PrivateAccount";
import { FaCrown } from "react-icons/fa";

function ProfileDetails({
  user,
  updatedUser,
  setUpdatedUser,
  follow,
  setFollow,
  playlists,
}: any) {
  const currentUrl = window.location.pathname;
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const followTargetUser = updatedUser?.id ? updatedUser : user;

  const closeLoginModal = () => {
    setShowLoginModal(false);
  };

  const isPlusUser = user?.is_subscribed;
  const isOwnProfile = loggedInUser?.id === user?.id;

  return (
    <>
      <div className="relative z-10 -mt-[70px] flex items-center gap-6 px-8 pb-6 max-xl:px-5 max-sm:-mt-[10vh] max-sm:flex-col max-sm:items-center max-sm:gap-4 max-sm:px-5 max-sm:text-center">
        {/* left: avatar + social icons */}
        <div className="flex shrink-0 flex-col items-center gap-4">
          <div className="relative inline-flex">
            {/* Crown */}
            {isPlusUser && (
              <div className="absolute right-3 top-3 z-50 rounded-full bg-[#F50537] p-2 shadow-[0_4px_14px_rgba(245,5,55,0.5)]">
                <FaCrown className="text-[16px] text-white max-sm:text-[13px]" />
              </div>
            )}

            {/* Avatar */}
            <div
              className={`flex items-center justify-center rounded-full ${
                isPlusUser
                  ? "bg-gradient-to-br from-[#F50537] to-red-400 p-[4px] shadow-[0_8px_30px_rgba(245,5,55,0.35)]"
                  : "p-[3px] shadow-[0_10px_40px_rgba(0,0,0,0.7)] ring-1 ring-white/15"
              }`}
            >
              <img
                src={user?.artwork_url}
                alt="profile"
                className={`h-[170px] max-h-[170px] w-[170px] max-w-[170px] rounded-full object-cover max-sm:h-[150px] max-sm:w-[150px] ${
                  isPlusUser ? "ring-2 ring-[#F50537]" : ""
                }`}
              />
            </div>
          </div>

          {/* social icons (under avatar) */}
          <div className="flex items-center justify-center gap-4 text-[#F50537]">
            <SocialMediaBtn user={user} />
          </div>

          {/* mobile-only stats */}
          <FollowFollowingSection
            user={user}
            className="justify-center sm:hidden"
          />
        </div>

        {/* middle: name + follow + bio */}
        <div className="min-w-0 flex-1 pb-1 max-sm:w-full">
          <div className="mt-3 flex flex-wrap items-center gap-4 max-sm:justify-center">
            <h1 className="font-rubik text-[40px] font-bold leading-none tracking-tight text-white max-xl:text-[30px] max-md:text-[28px] max-sm:text-[26px]">
              {user?.name}
            </h1>

            {isPlusUser && (
              <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#F50537]/40 bg-[#F50537]/10 px-3 py-1 text-[12px] font-semibold text-[#F50537]">
                <FaCrown className="text-[11px]" />
                Plus
              </span>
            )}

            {/* Follow inline with the name (other users only) */}
            {!isOwnProfile && (
              <FollowButton
                user={followTargetUser}
                setUpdatedUser={setUpdatedUser}
                follow={follow}
                setFollow={setFollow}
                setShowLoginModal={setShowLoginModal}
              />
            )}
          </div>

          <p className="mt-3 max-w-2xl text-sm font-medium leading-relaxed text-white/60 max-sm:mx-auto max-sm:text-xs">
            {user?.bio}
          </p>

          <div className="max-sm:flex max-sm:justify-center">
            {user &&
              user?.id !== loggedInUser?.id &&
              user?.activity_privacy === 1 && <PrivateAccount />}
          </div>
        </div>

        {/* right: message / settings */}
        <div className="flex shrink-0 items-center justify-end gap-3 pb-1 max-sm:w-full max-sm:justify-center">
          {isOwnProfile ? (
            <UserEditProfileButton />
          ) : (
            loggedInUser && <NewChatButton user={user} />
          )}

          {showLoginModal && (
            <LoginModel
              clickLogin={closeLoginModal}
              setShowLoginModal={setShowLoginModal}
              navigateUrl={currentUrl}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default ProfileDetails;